import { Injectable } from '@angular/core';
import { DefaultDataService, HttpUrlGenerator } from '@ngrx/data';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { ActuatorHealth } from 'src/rdsap-api/model/actuatorHealth';
import { ActuatorsService } from 'src/rdsap-api';

// Define the custom data service
// this service overrides the @ngrx/data default data service and fetches data with custom services
@Injectable()
export class RdSAPHealthDataService extends DefaultDataService<ActuatorHealth> {
  constructor(
    http: HttpClient,
    httpUrlGenerator: HttpUrlGenerator,
    private actuatorService: ActuatorsService
  ) {
    super('RdSAPHealth', http, httpUrlGenerator);
  }

  getAll(): Observable<ActuatorHealth[]> {
    return this.actuatorService.newGetActuatorHealth().pipe(
      map(data => [data]) // Wrap data in an array as NgRx Data expects an array
    );
  }
}
